import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { getCustomersByBootcamp, getUsers } from '../actions/api';
import { TEAM_LIVERY } from '../theme';
import { tally, fullName } from '../scoring';
import StatTable from './StatTable';

const REFRESH_MS = 30000;

const buildTeams = (customers, rosters) => {
  const myTeam = Cookies.get('team');
  return Object.keys(TEAM_LIVERY)
    .map((color) => {
      const reps = (rosters[`${color}Team`] || []).map((u) => ({
        id: u.id,
        name: fullName(u),
        calls: u.calls || 0,
        ...tally(customers.filter((c) => c.userId === u.id)),
      }));
      return { color, reps, points: reps.reduce((sum, r) => sum + r.points, 0) };
    })
    .filter((t) => t.reps.length > 0)
    // Your own team first, then by points.
    .sort((a, b) => (b.color === myTeam) - (a.color === myTeam) || b.points - a.points);
};

const TeamDashboard = () => {
  const [teams, setTeams] = useState(null);
  const [showCalls, setShowCalls] = useState(false);

  useEffect(() => {
    let alive = true;
    let timer;
    const load = async () => {
      try {
        const [customers, rosters] = await Promise.all([getCustomersByBootcamp(), getUsers()]);
        if (alive) {
          setTeams(buildTeams(customers, rosters || {}));
          setShowCalls(!!(rosters && rosters.tracksCalls));
        }
      } catch (e) {
        if (alive && teams === null) setTeams([]);
      }
      if (alive) timer = setTimeout(load, REFRESH_MS);
    };
    load();
    return () => {
      alive = false;
      clearTimeout(timer);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>Teams</h1>
          <p>Every rep’s numbers for this bootcamp. Select a column to sort.</p>
        </div>
      </div>

      {teams === null && <div className="loading-line">Loading teams…</div>}
      {teams && teams.length === 0 && (
        <div className="panel empty-state">
          <h2>No teams yet</h2>
          <p>Teams appear here once your trainer assigns reps for this bootcamp.</p>
        </div>
      )}
      {(teams || []).map((t) => {
        const livery = TEAM_LIVERY[t.color];
        return (
          <section key={t.color} className="panel team-block" style={{ borderLeftColor: livery.color }}
            aria-labelledby={`team-${t.color}`}>
            <div className="team-block-head">
              <h2 id={`team-${t.color}`}>{livery.label} team</h2>
              <span className="team-total">{t.points}<small>points</small></span>
            </div>
            <StatTable rows={t.reps} nameLabel="Rep" showCalls={showCalls} />
          </section>
        );
      })}
    </div>
  );
};

export default TeamDashboard;
